import './market-btn.scss'
import { ReactNode } from 'react'

interface MarketBtnProps {
  children: ReactNode
  type?: 1 | 2
  style?: React.CSSProperties
  onClick?: () => void
}

export default function MarketBtn(props: MarketBtnProps) {
  const { children, type, onClick, style } = Object.assign(
    { children: null, type: 1 },
    props
  )

  const handleClick = () => {
    onClick instanceof Function && onClick()
  }

  return (
    <div
      className={`market-btn btn${type}`}
      style={style}
      onClick={handleClick}
    >
      <p>
        <span>{children}</span>
        <span>{children}</span>
      </p>
    </div>
  )
}
